import { useRef, MutableRefObject } from 'react';

export function useBind<T>(data: T): MutableRefObject<T> {
  const dataBind = useRef<null | T>(null);

  dataBind.current = data;

  return dataBind as MutableRefObject<T>;
}
